import Navigationbar from "../Navigationbar";
import React, { useState} from "react";
import {useLocation} from "react-router-dom";
import {useAuth} from "../../authprovider";
import FilesCard from "./FilesCard"
import UsersCard from "./UsersComponent";
import ObjectDataCard from "./BuildingDataComponent";



export default function BuildingPage(){
    const {buildings} = useAuth();
    const location = useLocation();
    const building_id = location.hash.replace("#",'');
    const [building, setBuilding] = useState(undefined)

    if(building === undefined){
        buildings.getBuilding(building_id, response=>{
            const {success, error, content} = response;

            if(success === true){
                setBuilding(content)
            } else
                console.log(error)
        })
    }




    return (
        <>
            <Navigationbar/>
            <div className={"container"}>
                <div className={"row"}>
                    {building &&
                        <>
                            <ObjectDataCard data-building={building} />
                            <UsersCard data-building={building} />
                            <FilesCard data-building={building} />
                        </>
                    }
                </div>
            </div>


        </>
    )
}






